import React, { useRef } from 'react';
import ChatInput from '../ChatInput';

interface ChatInputFormProps {
    isDisabled?: boolean;
    isCompact?: boolean;
}

const ChatInputForm = React.forwardRef<
    HTMLFormElement,
    ChatInputFormProps & { ref?: React.RefObject<HTMLFormElement> }
>(({ isDisabled = false, isCompact = false }, ref) => {
    const formRef = useRef<HTMLFormElement>(null);

    // Expose ref to parent
    React.useImperativeHandle(ref, () => formRef.current as HTMLFormElement);

    return (
        <form
            ref={formRef}
            aria-disabled={isDisabled}
            className="mx-auto w-full max-w-5xl"
        >
            <ChatInput isCompact={isCompact} />
        </form>
    );
});

ChatInputForm.displayName = 'ChatInputForm';

export default ChatInputForm;
